import { FaWhatsapp } from "react-icons/fa"

export default function WhatsAppButton() {
  const phoneNumber = "21628718432"
  const message =
  "Bonjour, je souhaite obtenir plus d'informations sur vos produits textiles."
  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contacter sur WhatsApp"
      className="
        fixed
        bottom-5
        right-5
        z-50
        flex
        items-center
        gap-3
        bg-green-500
        text-white
        px-5
        py-4
        rounded-full
        shadow-xl
        hover:bg-green-600
        hover:scale-105
        transition-all
        duration-300
      "
    >
      <FaWhatsapp size={26} />

      <span className="hidden sm:block font-semibold">
        WhatsApp
      </span>
    </a>
  )
}